import * as React from "react";
const SvgBatteryLow = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M16 6.10526H14.5179V4H0V12.0337H14.5179V9.91158H16V6.10526ZM13.5 11H1V5H13.5V11Z" }), /* @__PURE__ */ React.createElement("path", { d: "M3.823 5.53271H1.54932V10.4843H3.823V5.53271Z" }));
export default SvgBatteryLow;
